export const DOMAIN_STATUS = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
        className: 'bg-primary',
        variant: 'light-sea-green',
    },
    ALERT: {
        key: 'ALERT',
        label: 'Alert',
        className: 'bg-golden-dream',
        variant: 'scarlet',
    },
    GRACE: {
        key: 'GRACE',
        label: 'Grace',
        className: 'bg-wisteria',
        variant: 'neon-blue',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
        className: 'bg-silver',
        variant: 'grey',
    },
    TRANSFERRED: {
        key: 'TRANSFERRED',
        label: 'Transferred',
        className: 'bg-silver',
        variant: 'grey',
    },
};

export const UNACCEPTABLE_DOMAIN_STATUS = [
    DOMAIN_STATUS.EXPIRED.key,
    DOMAIN_STATUS.GRACE.key,
    DOMAIN_STATUS.TRANSFERRED.key,
];

export const DOMAIN_RENEWABLE_STATUS = [
    DOMAIN_STATUS.ACTIVE.key,
    DOMAIN_STATUS.ALERT.key,
];

export const DOMAIN_REACTIVATABLE_STATUSES = [DOMAIN_STATUS.GRACE.key];

export const DOMAIN_STATUS_LIST = (() => {
    const arr = [];
    Object.keys(DOMAIN_STATUS).forEach((item) => {
        const obj = {
            label: DOMAIN_STATUS[item].label,
            key: DOMAIN_STATUS[item].key,
        };
        arr.push(obj);
    });
    return arr;
})();

export const EMAIL_STATUS = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
    },
};

export const ORDER_STATUS = {
    COMPLETE: {
        key: 'COMPLETE',
        label: 'Complete',
        value: 'Complete',
        className: 'bg-maya-blue',
        variant: 'light-sea-green',
    },
    PROCESSING: {
        key: 'PROCESSING',
        label: 'Processing',
        value: 'Processing',
        className: 'bg-golden-dream',
        variant: 'yellow-orange',
    },
    PENDING: {
        key: 'PENDING',
        label: 'Pending',
        value: 'Pending',
        className: 'bg-chino',
        variant: 'scarlet',
    },
    PAID: {
        key: 'PAID',
        label: 'Paid',
        value: 'Paid',
        className: 'bg-turquoise',
        variant: 'navy-blue',
    },
    CANCELLED: {
        key: 'CANCELLED',
        label: 'Cancelled',
        value: 'Cancelled',
        className: 'bg-silver',
        variant: 'grey',
    },
    REFUND: {
        key: 'REFUND',
        label: 'Refund',
        value: 'Refund',
        className: 'bg-gumbo',
        variant: 'neon-blue',
    },
    REFUNDED: {
        key: 'REFUNDED',
        label: 'Refunded',
        value: 'Refunded',
        className: 'bg-ocean-green',
        variant: 'yellow-orange',
    },
    SETUP: {
        key: 'SETUP',
        label: 'Setup',
        value: 'Setup',
        className: 'bg-allports',
        variant: 'tory-blue',
    },
    NEW: {
        key: 'NEW',
        label: 'To Pay',
        value: 'New',
        className: 'bg-chino',
        variant: 'scarlet',
    },
};

export const CLOUD_SERVER_STATUS = {
    ON: {
        key: 'ON',
        label: 'On',
        className: 'bg-primary',
        variant: 'navy-blue',
    },
    OFF: {
        key: 'OFF',
        label: 'Off',
        className: 'bg-silver',
        variant: 'grey',
    },
    SETTING_UP: {
        key: 'SETTING_UP',
        label: 'Setting Up',
        className: 'bg-golden-dream',
        variant: 'tory-blue',
    },
    SETUP_FAILED: {
        key: 'SETUP_FAILED',
        label: 'Setup Failed',
        className: 'bg-red',
        variant: 'scarlet',
    },
    BACKING_UP: {
        key: 'BACKING_UP',
        label: 'Backing Up',
        className: 'bg-golden-dream',
        variant: 'yellow-orange',
    },
    RESTORING: {
        key: 'RESTORING',
        label: 'Restoring',
        className: 'bg-golden-dream',
        variant: 'tory-blue',
    },
};

export const CLOUD_SERVER_BACKUP_STATUS = {
    ON: {
        key: 'ON',
        label: 'On',
        className: 'bg-primary',
        variant: 'navy-blue',
    },
    OFF: {
        key: 'OFF',
        label: 'Off',
        className: 'bg-silver',
        variant: 'grey',
    },
};

export const CLOUD_HOSTING_STATUS = {
    RUNNING: {
        key: 'RUNNING',
        label: 'Running',
        className: 'bg-primary',
        variant: 'navy-blue',
    },
    STOPPED: {
        key: 'STOPPED',
        label: 'Stopped',
        className: 'bg-silver',
        variant: 'grey',
    },
    SETTING_UP: {
        key: 'SETTING_UP',
        label: 'Setting Up',
        className: 'bg-golden-dream',
        variant: 'tory-blue',
    },
    SETUP_FAILED: {
        key: 'SETUP_FAILED',
        label: 'Setup Failed',
        className: 'bg-red',
        variant: 'scarlet',
    },
};

export const PACKAGE_STATUS = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
        className: 'bg-primary',
        variant: 'light-sea-green',
    },
    PROCESSING: {
        key: 'PROCESSING',
        label: 'Processing',
        className: 'bg-golden-dream',
        variant: 'yellow-orange',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
        className: 'bg-silver',
        variant: 'grey',
    },
    DELETED: {
        key: 'DELETED',
        label: 'Deleted',
        className: 'bg-venetian-red',
        variant: 'scarlet',
    },
    INACTIVE: {
        key: 'INACTIVE',
        label: 'Inactive',
        className: 'bg-silver',
        variant: 'grey',
    },
    SUSPENDED: {
        key: 'SUSPENDED',
        label: 'Suspended',
        className: 'bg-pickled-bluewood',
        variant: 'pickled-bluewood',
    },
};

export const RENEWABLE_STATUS = [
    PACKAGE_STATUS.ACTIVE.key,
    PACKAGE_STATUS.EXPIRED.key,
];

export const CLOUD_SERVER_STORAGE_EXTENDABLE_STATUS = [
    PACKAGE_STATUS.ACTIVE.key,
];

export const PACKAGE_METADATA = {
    PACKAGE_BANDWIDTH: {
        key: 'PACKAGE_BANDWIDTH',
        value: 'Bandwidth',
    },
    PACKAGE_RAM: {
        key: 'PACKAGE_RAM',
        value: 'Ram',
    },
    PACKAGE_STORAGE: {
        key: 'PACKAGE_STORAGE',
        value: 'Storage',
    },
    ADDITIONAL_IP: {
        key: 'ADDITIONAL_IP',
        value: 'Additional IP',
    },
    ADDITIONAL_STORAGE: {
        key: 'ADDITIONAL_STORAGE',
        value: 'cloud-server.storage_package',
    },
    EXTEND_STORAGE: {
        key: 'EXTEND_STORAGE',
        value: 'cloud-server.additional_storage',
    },
    OS: {
        key: 'OS',
        value: 'Operating System',
    },
    PACKAGE_CPU: {
        key: 'PACKAGE_CPU',
        value: 'vCPU',
    },
    PACKAGE_FILE_STORAGE: {
        key: 'PACKAGE_FILE_STORAGE',
        value: 'File Storage',
    },
    PACKAGE_DB_STORAGE: {
        key: 'PACKAGE_DB_STORAGE',
        value: 'Database Storage',
    },
    PACKAGE_APP: {
        key: 'PACKAGE_APP',
        value: 'Application',
    },
    NAMESERVERS: {
        key: 'NAMESERVERS',
        value: 'Nameservers',
    },
    PACKAGE_DATA_CENTER: {
        key: 'PACKAGE_DATA_CENTER',
        value: 'Data Center',
    },
    ADDITIONAL_DB_STORAGE: {
        key: 'ADDITIONAL_DB_STORAGE',
        value: 'Additional Database Storage',
    },
    ADDITIONAL_FILE_STORAGE: {
        key: 'ADDITIONAL_FILE_STORAGE',
        value: 'Additional File Storage',
    },
};

export const SHARED_HOSTING_SERVER_STATUS = {
    ON: {
        key: 'ON',
        label: 'On',
        className: 'bg-primary',
        variant: 'navy-blue',
    },
    OFF: {
        key: 'OFF',
        label: 'Off',
        className: 'bg-silver',
        variant: 'grey',
    },
};

export const SHARED_HOSTING_STATUS = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
        className: 'bg-primary',
        variant: 'light-sea-green',
    },
    ALERT: {
        key: 'ALERT',
        label: 'Alert',
        className: 'bg-golden-dream',
        variant: 'scarlet',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
        className: 'bg-silver',
        variant: 'grey',
    },
    DELETED: {
        key: 'DELETED',
        label: 'Deleted',
        className: 'bg-venetian-red',
        variant: 'scarlet',
    },
    SUSPENDED: {
        key: 'SUSPENDED',
        label: 'Suspended',
        className: 'bg-pickled-bluewood',
        variant: 'pickled-bluewood',
    },
};

export const WORDPRESS_HOSTING_SERVER_STATUS = {
    ON: {
        key: 'ON',
        label: 'On',
        className: 'bg-primary',
        variant: 'navy-blue',
    },
    OFF: {
        key: 'OFF',
        label: 'Off',
        className: 'bg-silver',
        variant: 'grey',
    },
};

export const WORDPRESS_HOSTING_STATUS = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
        className: 'bg-primary',
        variant: 'light-sea-green',
    },
    ALERT: {
        key: 'ALERT',
        label: 'Alert',
        className: 'bg-golden-dream',
        variant: 'scarlet',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
        className: 'bg-silver',
        variant: 'grey',
    },
    DELETED: {
        key: 'DELETED',
        label: 'Deleted',
        className: 'bg-venetian-red',
        variant: 'scarlet',
    },
};

export const SSL_STATUSES = {
    ACTIVE: {
        key: 'ACTIVE',
        label: 'Active',
        className: '',
        variant: 'light-sea-green',
    },
    NEW: {
        key: 'NEW',
        label: 'New',
        className: '',
        variant: 'navy-blue',
    },
    RENEWAL: {
        key: 'RENEWAL',
        label: 'Renewal',
        className: '',
        variant: 'navy-blue',
    },
    PENDING: {
        key: 'PENDING',
        label: 'Pending',
        className: '',
        variant: 'yellow-orange',
    },
    PAUSED: {
        key: 'PAUSED',
        label: 'Paused',
        className: '',
        variant: 'yellow-orange',
    },
    REPLACED: {
        key: 'REPLACED',
        label: 'Replaced',
        className: '',
        variant: 'light-sea-green',
    },
    REVOKED: {
        key: 'REVOKED',
        label: 'Revoked',
        className: '',
        variant: 'grey',
    },
    EXPIRED: {
        key: 'EXPIRED',
        label: 'Expired',
        className: '',
        variant: 'grey',
    },
};
export const TRANSACTION_STATUSES = {
    PENDING: {
        key: 'PENDING',
        label: 'Pending',
        className: 'bg-chino',
        variant: 'scarlet',
    },
    COMPLETE: {
        key: 'COMPLETE',
        label: 'Complete',
        className: 'bg-maya-blue',
        variant: 'light-sea-green',
    },
    FAILED: {
        key: 'FAILED',
        label: 'Failed',
        className: 'bg-red',
        variant: 'scarlet',
    },
    CANCELLED: {
        key: 'CANCELLED',
        label: 'Cancelled',
        className: 'bg-silver',
        variant: 'grey',
    },
    PROCESSING: {
        key: 'PROCESSING',
        label: 'Processing',
        className: 'bg-golden-dream',
        variant: 'yellow-orange',
    },
};
export const TRANSACTION_DETAIL_STATUSES = {
    PENDING: {
        key: 'PENDING',
        label: 'Pending',
        className: 'bg-chino',
        variant: 'scarlet',
    },
    COMPLETE: {
        key: 'COMPLETE',
        label: 'Complete',
        className: 'bg-maya-blue',
        variant: 'light-sea-green',
    },
    FAILED: {
        key: 'FAILED',
        label: 'Failed',
        className: 'bg-red',
        variant: 'scarlet',
    },
    CANCELLED: {
        key: 'CANCELLED',
        label: 'Cancelled',
        className: 'bg-silver',
        variant: 'grey',
    },
};
export const WORDPRESS_HOSTING_ACTIONABLE_STATUS = [
    WORDPRESS_HOSTING_STATUS.ACTIVE.key,
    WORDPRESS_HOSTING_STATUS.ALERT.key,
    WORDPRESS_HOSTING_STATUS.EXPIRED.key,
];

export const SHARED_HOSTING_ACTIONABLE_STATUS = [
    SHARED_HOSTING_STATUS.ACTIVE.key,
    SHARED_HOSTING_STATUS.ALERT.key,
    SHARED_HOSTING_STATUS.EXPIRED.key,
];

export const DOWNLOADABLE_RECEIPT_STATUS = [
    ORDER_STATUS.COMPLETE.key,
    ORDER_STATUS.REFUNDED.key,
];

export const CHANGEABLE_ROOT_PASSWORD_CLOUD_SERVER_STATUSES = [
    CLOUD_SERVER_STATUS.ON.key,
];
